import { MessageCircle } from "lucide-react";

export function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/393357810986?text=Ciao%20Maurizi%2C%20vorrei%20info%20su..."
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contattaci su WhatsApp"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg flex items-center justify-center transition-transform hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
